
<div fxLayout="row" class="snack-container">
  <div>
    <mat-icon svgIcon="{{ getIcon }}"></mat-icon>
    <span class="snack-text">{{ data.message }}</span>
  </div>
</div>
  